export const DocRouting = [
  {
    path: "/tender/doc/library",
    name: "tender-doc-library",
    meta: { title: "投标文档管理" },
    component: () =>
      import(/* webpackChunkName: "tender-doc" */ "@/views/tender/doc/library/index.vue"),
  },
  {
    hidden: true,
    path: "/tender/doc/list/:name",
    name: "tender-doc-list",
    meta: { title: "投标文档管理" },
    component: () =>
      import(/* webpackChunkName: "tender-doc" */ "@/views/tender/doc/list/index.vue"),
  },
];
